module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-content g-pt-20 g-pt-0--md",
    attrs: {
      "id": "nav-5-3-primary-ver"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.items.keys()), function(group, index) {
    return (_vm.items != null) ? _c('div', [_c('help-item', {
      attrs: {
        "id": group.replace(/\s+/g, '') + '-div',
        "section": group,
        "items": _vm.items.get(group)
      }
    }), _vm._v(" "), _c('br'), _c('br'), _c('br')], 1) : _vm._e()
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-max-width-645 text-center mx-auto g-mt-60 g-mb-0"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("Frequently Asked Questions")]), _vm._v(" "), _c('p', {
    staticClass: "g-font-size-20"
  }, [_vm._v("Below are the answers to some frequently asked questions.")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1fd1870a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fd1870a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/helpData/HelpCenter.vue
// module id = 487
// module chunks = 4